import React, { Fragment } from 'react';

import { CssBaseline, Grid } from '@material-ui/core';
import { createMuiTheme, makeStyles, ThemeProvider } from '@material-ui/core/styles';

import Settings from '../../static/models/Settings';
import { defaultTheme } from '../../theme/defaultTheme';
import ProviderSearchPage from '../page-components/provider-search-page/ProviderSearchPage';
import Footer from './limb-components/footer/Footer';

const theme = createMuiTheme(defaultTheme);

const useStyles = makeStyles({
    pageContainer: {
        minHeight: '100vh',
    },
    contentContainer: {
        display: 'flex',
        flexGrow: 1,
    },
});

export interface AppProps {
    settings: Settings;
}

const App: React.FunctionComponent<AppProps> = ({ settings }: AppProps) => {
    const classes = useStyles();
    return (
        <ThemeProvider theme={theme}>
            <CssBaseline />
            <Grid container direction="column" justify="space-between" className={classes.pageContainer}>
                <Grid item className={classes.contentContainer}>
                    <ProviderSearchPage settings={settings} />
                </Grid>
                <Fragment>
                    <Footer />
                </Fragment>
            </Grid>
        </ThemeProvider>
    );
};

export default App;
